/**
 * @file       Loading.constant.ts
 * @desc       Settings for the shared app-level loading overlay
 * @version    1.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or
 *             altered in anyway without expressed written permission from
 *             MindShare HDV LLC.
 */
import { HttpContextToken } from '@angular/common/http';

const LOADING_SHOW_DELAY_MS = 300;

/**
 * Requests whose URL contains one of these parts never show the overlay:
 * autocomplete lookups, lock heartbeats, token refresh, import polling,
 * and dashboard widgets (they render their own spinners).
 */
const LOADING_SKIP_URL_PARTS: ReadonlyArray<string> = Object.freeze(
[
    'matchBy',
    'partialMatch',
    'task/renewEditLock',
    'task/getEditLock',
    'token/refresh',
    'getImportStatus',
    'dashboard/'
]);

const SKIP_LOADING = new HttpContextToken<boolean>(() =>
{
    return false;
});

export
{
    LOADING_SHOW_DELAY_MS,
    LOADING_SKIP_URL_PARTS,
    SKIP_LOADING
};
